import { filterNotEmpty } from 'utils/data/listHelpers';
import { NavItem } from 'common/HorizontalNavPage';
import { TABS } from './UserInterfaceSettings.types';
import { useUserInterfaceSettingsIntl } from './translations/useUserInterfaceSettingsIntl';

export const useGetInterfaceTabs = () => {
  const intl = useUserInterfaceSettingsIntl();

  const getTabs = (): NavItem[] =>
    filterNotEmpty<NavItem>([
      { label: intl.general, path: TABS.GENERAL, 'data-test': 'general__config__tab', permissions: [] },
      { label: intl.home, path: TABS.HOME, 'data-test': 'myutmost__config__tab', permissions: [] },
      { label: intl.insights, path: TABS.INSIGHTS, 'data-test': 'dashboards__config__tab', permissions: [] },
      {
        label: intl.jobApplications,
        path: TABS.JOB_APPLICATIONS,
        'data-test': 'job_applications_hub__config_tab',
        permissions: []
      },
      {
        label: intl.engagements,
        path: TABS.ENGAGEMENT_HUB,
        'data-test': 'engagement__hub__config__tab',
        permissions: []
      },
      { label: intl.workers, path: TABS.WORKERS, 'data-test': 'worker__hub__config__tab', permissions: [] },
      {
        label: intl.workerProfile,
        path: TABS.WORKER_PROFILE,
        'data-test': 'worker_profile__config_tab',
        permissions: []
      },
      {
        label: intl.suppliers,
        path: TABS.SUPPLIERS,
        'data-test': 'supplier_hub__config_tab',
        permissions: []
      }
    ]);

  return {
    getTabs
  };
};
